export const REQUEST = 'AUTH_GOOGLE_SIGNIN_REQUEST';
export const SUCCESS = 'AUTH_GOOGLE_SIGNIN_SUCCESS';
export const FAILURE = 'AUTH_GOOGLE_SIGNIN_FAILURE';

// `credential` is the Google-signed ID token from the GIS button callback.
export const fetchRequest = (credential) => ({
  type: REQUEST,
  payload: { credential }
});

export const fetchSuccess = (data) => ({
  type: SUCCESS,
  payload: data
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
